import {
  fetchUser,
  fetchItems,
  fetchIdsByType
} from '../api'
import axios from 'axios';
import { authHeader } from '../util/header'
import moment from 'moment';
export default {
  async GET_I18N_LOCALE({ commit, state }, opts) {
    try {
      //if (!state.locale) {
        let url = translation_uri;
        const options = {
          method: 'POST',
          //headers: authHeader(opts.vueObj),
          data: {
            "lang" : state.currentLanguage,
            "page" : state.currentPage,
            "device": "Desktop",
          },
          url,
        }
        let response = await axios(options);
        let locale = response.data
        commit('setLocale', { locale })
      //}
    } catch (error) {
      console.error(error);
    }
  },
  // SET_LANGUAGE({ commit }, lang) {
  //   commit('setLanguage', { lang })
  // },
  SET_CUST_LANGUAGE({ commit }, lang) {
    commit('setLanguage', { lang })
  },
  SET_CURRENCY({ commit }, currency) {
    let cur = currency.split(" ")
    commit('setCurrency',  cur[0] )
    commit('setCurrencyName',  currency )
  },
  SET_CONTAINER_CLASS({ commit }, routeName) {
    let classValue = null;
    // Set container class name
    switch (routeName) {
      case 'flight': classValue = 'fltSearch'; break;
      case 'hotel': classValue = 'htlSearch'; break;
      case 'fph': classValue = 'fphSearch'; break;
    }
    commit('setContainerClass', classValue)
  },
  SET_LAYOUT({ commit }, routeName) {
    let layoutValue = null;

    switch (routeName) {
      case 'dashboard':
      default:
        layoutValue = 'desktop-layout';
        break;
    }
    commit('setLayout', layoutValue);
  },
  SET_SEARCHRQ({ commit }, searchRQ) {
    commit('setSearchRQ', searchRQ);
  },
  SET_SEARCHRS({ commit }, searchRS) {
    commit('setSearchRS', searchRS);
  },
  SET_REVIEWRS({ commit }, reviewRS) {
    commit('setReviewRS', reviewRS);
  },
  SET_PRICERS({ commit }, priceRS) {
    commit('setPriceRS', priceRS);
  },
  SET_CUSTOMERS({ commit }, travellers) {
    commit('setTravellers', travellers);
  },
  SET_PNRRS({ commit }, pnrRS) {
    commit('setPNRRS', pnrRS);
  },  
  SET_TICKETRS({ commit }, ticketRS) {
    commit('setTicketRS', ticketRS);
  },
  SET_MODIFY({commit}, modify) {
    commit('setModify', modify);
  },
  async httpPost({ commit }, opts) {
    try {
      const options = {
        method: 'POST',
        headers: authHeader(opts.vueObj),
        data: opts.body,
        url: opts.uri,
      }
      let response = await axios(options);
      if (response && response.data)
        return response.data;
      return null;
    } catch (e) {
    }
  },
  async dateFormat({ commit }, options) {
    try {
      return moment(options.date).format(options.format)
    } catch (e) {
      return "";
    }
  },


  // top links fetching
  async FETCH_SSC({ commit }, vue) {
    console.log('vue', vue.query)
    try {
      const options = {
        method: 'POST',
        headers: authHeader(vue),
        data: vue.query,
        url: chs_uri + 'ssc/staticfetch'
      };
      let response = await axios(options);
      if (response && response.data)
        return response.data;
    } catch (e) {
      console.log("error in calling http post call", e);
    }
  },
  // SET_CUSTOMER_DATA({ commit }, customerData) {
  //   let lang = customerData.lang;
  //   let cur = customerData.cur;
  //   commit('setCustomerInfo', customerData)
  //   commit('setLanguage', {lang})
  //   commit('setCurrency', { cur })
  // },
}



// WEBPACK FOOTER //
// src/store/actions.js